module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ivu-select-dropdown",
    class: _vm.className,
    style: (_vm.styles)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd10c658"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/select/dropdown.vue
// module id = 1409
// module chunks = 107